import { render, staticRenderFns } from "./CompaniesDropDown.vue?vue&type=template&id=55fa5a3a"
import script from "./CompaniesDropDown.vue?vue&type=script&lang=js"
export * from "./CompaniesDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports